export default {
    'name': 'citation-nopatent',
    'label': 'structureTable.nopatent',
    'getComponent': () => import('./citation-nopatent.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/citation/non-patent',
};
